export const LOGO_URL = "https://customer-assets.emergentagent.com/job_recharge-rapide-clim/artifacts/a1qhcf6l_climomax13-logo.png";

export default function Logo({ className = "h-10 w-auto", testid = "brand-logo" }) {
  return (
    <img
      src={LOGO_URL}
      alt="ClimOmax13"
      data-testid={testid}
      className={`${className} mix-blend-screen select-none`}
      draggable={false}
    />
  );
}
